export class ValueDisplay {
    public display: string;
    public value: number;
}
